import { render, staticRenderFns } from "./ContentButtons.vue?vue&type=template&id=5aecbd48&scoped=true&"
import script from "./ContentButtons.vue?vue&type=script&lang=js&"
export * from "./ContentButtons.vue?vue&type=script&lang=js&"
import style0 from "./ContentButtons.vue?vue&type=style&index=0&id=5aecbd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aecbd48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
